// Dependencies
import React, { useState, useRef, useEffect } from "react";

// Modules
import { useSelector } from "react-redux";

// App
import { serverUrl, apiEndpoints } from "../../config";
import { getOnlineNode } from "../../core/getNode";
import PostImage from "../postImage";
import PostBody from "../postBody";
import SinglesHeader from "../singlesHeader";
import { alertMessages } from "../alertMessages";
import Error from "../error";

// UI components
import { CircularProgress } from "@mui/material";
import SkeletonSingleScreen from "../skeleton-screens/skeletonSingleScreen";

export default function Contribute(props) {
  const [iframeLoading, setIframeLoading] = useState(true);
  const iframeRef = useRef(null);
  const user = useSelector((state) => state).authReducer.user;

  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getOnlineNode(apiEndpoints.contribute, user.access_token)
      .then((response) => {
        if (response.data.rows[0]) {
          setData(response.data.rows[0]);
          setIsLoading(false);
        } else {
          _setError(true, 0, alertMessages.requestError.message);
        }
      })
      .catch((_error) => {
        if (_error.response) {
          _setError(true, _error.response.status, _error.response.statusText);
        } else if (_error.request) {
          _setError(true, 0, alertMessages.requestError.message);
        } else {
          _setError(true, 0, alertMessages.unkownError.message);
        }
      });
    // eslint-disable-next-line
  }, []);

  /**
   * @function setError
   * @description Updates the state of the component upon an error
   * @param {boolean} _isError
   * @param {int} _errorStatus
   * @param {string} _errorMessage
   */
  const _setError = (_isError, _errorStatus, _errorMessage) => {
    setIsLoading(false);

    setIsError(_isError);
    setErrorStatus(_errorStatus);
    setErrorMessage(_errorMessage);
  };

  if (isLoading) {
    return <SkeletonSingleScreen />;
  } else {
    return (
      <>
        {isError ? (
          <Error status={errorStatus} message={errorMessage} />
        ) : (
          <main className="contribute single">
            <article className="article">
              <SinglesHeader
                title={data?.title ? data.title : ""}
                hideBack={true}
                backBtnText={""}
              />

              {(data?.uri || data?.url) && (
                <PostImage
                  imgSrc={data?.uri || data?.url}
                  nid={data?.nid}
                />
              )}

              <div className="article__body">
                <PostBody body={data?.body ? data.body : ''} />
              </div>

              <div className="article__body pt-5">
                <div className="ratio ratio-4x3" style={{ height: "100vh" }}>
                  {data?.webform && (
                    <>
                      {iframeLoading && (
                        <div className="w-100 h-100 text-center">
                          <CircularProgress />
                        </div>
                      )}
                      <iframe
                        className={`${iframeLoading && "invisible"}`}
                        src={`${serverUrl}/node/${data.webform}?app=true`}
                        ref={iframeRef}
                        style={{ width: "100%", height: "1080px", border: "none" }}
                        title="Iframe Content"
                        onLoad={(iframe) => {
                          setIframeLoading(false);
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            </article>
          </main>)}
      </>
    );
  }
}
